





















































































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';

import Checkbox from '@/components/Checkbox.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import SimplePagination from '@/components/SimplePagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

interface ReportParams {
  startperiode: String;
  endperiode: String;
  paymentstart: String;
  paymentend: String;
  transactionNumber: String;
  email: String;
  phoneNumber: String;
  status: String;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    Checkbox,
    ActionPopup,
    SimplePagination,
  },
  computed: mapState(['user']),
  methods: {
    format,
  },
})
export default class BulkInvoiceReportTable extends Vue {
  user!: {
    user: User;
  };

  loading = true;
  listDataBullkInvoice: any[] = [];

  // merchantLoginData: any = this.$store.state.user.user.merchant;
  params: ReportParams = {} as ReportParams;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  format!: typeof format;

  openDetail(id: number) {
    this.$router.push(`/easyinvoice/etransaction/bulkinvoicedetail/${id}`);
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }
  async getBulkInvoive(parameters: ReportParams, page = 1) {
    this.params = parameters;
    try {
      this.loading = true;
      let today = new Date();
      let lastweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 90);
      const startperiode = this.params.startperiode.length === 0 ? dayjs(lastweek).format('MM/DD/YYYY') : this.params.startperiode;
      const endperiode = this.params.endperiode.length === 0 ? dayjs(Date()).format('MM/DD/YYYY') : this.params.endperiode;
      const paymentstart = this.params.paymentstart.length === 0 ? undefined : this.params.paymentstart;
      const paymentend = this.params.paymentend.length === 0 ? undefined : this.params.paymentend;
      const transactionNumber = this.params.transactionNumber.length === 0 ? undefined : this.params.transactionNumber;
      const email = this.params.email.length === 0 ? undefined : this.params.email;
      const phoneNumber = this.params.phoneNumber.length === 0 ? undefined : this.params.phoneNumber;
      const status = this.params.status.length === 0 ? "all" : this.params.status;

      const { data } = await api.post('/easyinvoice/invoices_list_bulk', {
        /* eslint-disable-next-line @typescript-eslint/camelcase */
        page,
        start_date_upload: startperiode,
        end_date_upload: endperiode,
        start_date_payment: paymentstart,
        end_date_payment: paymentend,
        status: status,
        start: 0,
        length: 10,
        user_group: 5,
        phone: phoneNumber,
        transaction_number: transactionNumber,
        emailcustomer: email,
        user_id: this.user.user.id,
      });
      if (data.data) {
        this.page = page;
        this.listDataBullkInvoice = data.data.data;
        this.totalPage = Math.ceil(data.total / data.per_page);
        this.from = data.from;
        this.to = data.to;
        this.totalItem = data.total;
      }
      // showToast(ToastType.SUCCESS, 'Data Transaction All Loaded', 'finished');
      // if(data.total === 0){
      //   showToast(ToastType.FAILED, 'Oops… Sorry, data not allowed','Change your filter');
      // }
      this.loading = false;
      return null;
    } catch (err) {
      // console.log(err);
      // showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data.error.errors[0].message);
      this.loading = false;
      return err as AxiosError;
    }
  }
}
